import styled from 'styled-components'

export const SectionHeading = styled.h1`
  font-weight: bold;
  font-family: Roboto;
  font-size: 3rem;
`
